import type { MaybeRef } from '@vueuse/core'
import { APIError } from '../api/_error/APIError'
import { useSidebarStore } from '../stores/sidebar'
import type { Elemental } from '../types/elemental'
import { useDuplicateElemental } from './mutations/elemetal/useDuplicateElemental'

export function useDuplicate(element: MaybeRef<Elemental | null | undefined>, parentListId?: string | number) {
  const firebaseUser = useUser()
  const router = useRouter()
  const { mutate, isPending } = useDuplicateElemental()
  const { toggleElementOpen, goToView, openMainList, state } = useSidebarStore()
  const toast = useToast()

  async function duplicate() {
    const elemental = unref(element)
    if (!elemental || !elemental.elementalTypeId === undefined || !elemental.id || !firebaseUser.value)
      return
    const isOwner = elemental.user.id === firebaseUser.value.id
    const isList = elemental.isList
    const path = getElementalTypeRoute(elemental.isList ? ElementalTypeEnum.List : elemental.elementalTypeId!)
    mutate({
      elementalType: elemental.isList ? ElementalTypeEnum.List : elemental.elementalTypeId!,
      elementalId: elemental.id,
      listId: isOwner ? parentListId : undefined,
    }, {
      onSuccess: (data) => {
        if (!data)
          return
        const link = `/${path}/${data.url}/edit`
        router.push(link)
        const typeRoute = getElementalTypeRoute(data.elementalTypeId!)
        openMainList(typeRoute)
        if (isList)
          toggleElementOpen(data.id, parentListId ? `${parentListId}` : null, true)
        if (state.mode !== 'folder')
          goToView()
      },
      onError: (error) => {
        if (error instanceof APIError) {
          toast.warning(error.message)
          return
        }
        let errorMessage = ''

        if (isList && elemental.isPremium)
          errorMessage = 'You can\'t duplicate a premium list'

        else
          errorMessage = `Duplicating ${path} failed`

        toast.error(errorMessage)
      },
    })
  }

  return {
    isPending,
    duplicate,
  }
}
